'use client';

import React, { useEffect, useRef } from 'react';
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import './globals.css';
import { SpeedInsights } from "@vercel/speed-insights/next";
import { Analytics } from "@vercel/analytics/react";
import { LocaleProvider } from '@/lib/i18n/LocaleProvider';

gsap.registerPlugin(useGSAP, ScrollTrigger);

export default function RootLayout({ children }) {
    const lenisRef = useRef(null);

    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            touchMultiplier: 2,
        });
        lenisRef.current = lenis;

        const onScroll = () => ScrollTrigger.update();
        lenis.on('scroll', onScroll);

        const tickerCb = (time) => {
            lenis.raf(time * 1000);
        };
        gsap.ticker.add(tickerCb);
        gsap.ticker.lagSmoothing(0);

        return () => {
            lenis.off('scroll', onScroll);
            gsap.ticker.remove(tickerCb);
            lenis.destroy();
            lenisRef.current = null;
        };
    }, []);

    return (
        <html lang="de">
            <body>
                <LocaleProvider>
                    <div className="flex flex-col min-h-screen">
                        {children}
                        <SpeedInsights />
                        <Analytics />
                    </div>
                </LocaleProvider>
            </body>
        </html>
    );
}
